<template>
  <div class="log-info">
    <div class="card">
      <div class="card-header">
        <span class="card-title">日志信息</span>
      </div>
      <div class="card-body">
        <el-table :data="currentPageLogs" border stripe :header-cell-style="{background: '#fff6e8',color: '#515a6e'}">
          <el-table-column prop="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="id" label="ID" width="120" align="center"></el-table-column>
          <el-table-column prop="module" label="模块" width="120" align="center"></el-table-column>
          <el-table-column prop="message" label="日志信息" min-width="320"></el-table-column>
          <el-table-column prop="status" label="操作结果" width="100" align="center">
            <template slot-scope="scope">
              <div :class="[scope.row.status === '成功' ? 'log-success' : 'log-danger']">
                  {{ scope.row.status }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="操作时间" width="160" align="center"></el-table-column>
          <el-table-column prop="ip" label="IP地址" width="150" align="center"></el-table-column>
        </el-table>
        
        <div class="pages">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logs: [
        {
          index: 1,
          id: '258087',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-15 21:38',
          ip: '210.117.227.70'
        },
        {
          index: 2,
          id: '258086',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-15 21:30',
          ip: '210.117.227.70'
        },
        {
          index: 3,
          id: '258085',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-15 08:58',
          ip: '210.117.227.70'
        },
        {
          index: 4,
          id: '258084',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-15 03:38',
          ip: '210.117.227.70'
        },
        {
          index: 5,
          id: '258083',
          module: '登陆模块',
          message: '打开项目成员表',
          status: '失败',
          time: '2025-12-14 17:07',
          ip: '210.117.227.70'
        },
        {
          index: 6,
          id: '258082',
          module: '登陆模块',
          message: '打开项目表成功',
          status: '成功',
          time: '2025-12-11 12:59',
          ip: '210.117.227.70'
        },
        {
          index: 7,
          id: '258081',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-10 23:51',
          ip: '210.117.227.70'
        },
        {
          index: 8,
          id: '258080',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-10 21:14',
          ip: '210.117.227.70'
        },
        {
          index: 9,
          id: '258079',
          module: '登陆模块',
          message: '保存签到数据【活动ID:518578198】，【联谊课时:16836】',
          status: '成功',
          time: '2025-12-10 05:07',
          ip: '210.117.227.70'
        },
        {
          index: 10,
          id: '258078',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-09 18:07',
          ip: '210.117.227.70'
        }
      ],
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    total() {
      return this.logs.length
    },
    currentPageLogs() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.logs.slice(start, end)
    }
  },
  methods: {
    handleSizeChange() {
    },
    handleCurrentChange(index) {
      this.currentPage = index
    }
  }
}
</script>

<style lang="less" scoped>
.log-info {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }

    .log-success {
      font-size: 14px;
      color: #3aa85b;
    }
    .log-danger {
      font-size: 14px;
      color: #e45c5c;
    }

    .pages {
      margin-top: 34px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>

<style lang="less" scoped>
 ::v-deep .el-pager li.active {
    color: #ED9D26;
  }
</style>
